import { render } from "./materialVideo.vue?vue&type=template&id=d000c86e"
import script from "./materialVideo.vue?vue&type=script&lang=js"
export * from "./materialVideo.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contentCenter/materialVideo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d000c86e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d000c86e', __exports__)) {
    console.log('reload')
    api.reload('d000c86e', __exports__)
  }
  
  module.hot.accept("./materialVideo.vue?vue&type=template&id=d000c86e", () => {
    console.log('re-render')
    api.rerender('d000c86e', render)
  })

}


export default __exports__